// FOR TESTING. DELETE WHILE IMPLEMENTING REAL DATA
import { DataProvider } from './dataProvider.jsx';

export const mockPromotionalCampaignsConversionData = {
    cities: [
        { name: 'Warszawa', value: '63.6%' },
        { name: 'Poznań', value: '60.1%' },
        { name: 'Gdańsk', value: '56.4%' },
        { name: 'Kraków', value: '48.1%' },
        { name: 'Wrocław', value: '44.2%' },
    ],
    voivodeships: [
        { name: 'Mazowieckie', value: '67.5%' },
        { name: 'Śląskie', value: '58.2%' },
        { name: 'Wielkopolskie', value: '44.5%' },
        { name: 'Małopolskie', value: '33.5%' },
        { name: 'Dolnośląskie', value: '31.8%' },
    ],
    deviceGroups: [
        { name: 'Z-A23', value: '74.2%' },
        { name: 'Z-A39', value: '65.5%' },
        { name: 'Z-B12', value: '55.4%' },
        { name: 'Z-B20', value: '44.3%' },
        { name: 'Z-A03', value: '36.6%' },
    ],
};

export const mockPromotionalCampaignsViewsData = {
    cities: [
        { name: 'Warszawa', value: '85.4%' },
        { name: 'Poznań', value: '79.8%' },
        { name: 'Gdańsk', value: '72.1%' },
        { name: 'Kraków', value: '66.9%' },
        { name: 'Wrocław', value: '61.7%' },
    ],
    voivodeships: [
        { name: 'Mazowieckie', value: '89.2%' },
        { name: 'Śląskie', value: '78.5%' },
        { name: 'Wielkopolskie', value: '65.1%' },
        { name: 'Małopolskie', value: '54.8%' },
        { name: 'Dolnośląskie', value: '48.3%' },
    ],
    deviceGroups: [
        { name: 'Z-A23', value: '92.1%' },
        { name: 'Z-A39', value: '87.8%' },
        { name: 'Z-B12', value: '76.2%' },
        { name: 'Z-B20', value: '69.5%' },
        { name: 'Z-A03', value: '58.9%' },
    ],
};

const mockProductBrands = [
    'Coca-Cola',
    'Pepsi',
    'Sprite',
    'Fanta',
    '7UP',
    'Mountain Dew',
    'Dr Pepper',
    'Schweppes',
    'Red Bull',
    'Monster',
    'Lipton',
    'Nestea',
    'Powerade',
    'Gatorade',
    'Żywiec Zdrój',
];

const mockDeviceGroups = [
    { id: 1, name: 'G-88829' },
    { id: 2, name: 'G-98989' },
    { id: 3, name: 'G-12456' },
    { id: 4, name: 'G-77234' },
    { id: 5, name: 'G-45678' },
    { id: 6, name: 'G-33291' },
    { id: 7, name: 'G-56712' },
];

const mockCoupons = [
    { id: 1, deviceGroupIds: [1, 2, 3], name: 'Rabat 5% za 3 zwrócone puszki', code: 'CANS3-5OFF' },
    { id: 2, deviceGroupIds: [1, 2], name: 'Rabat 10% za 5 zwróconych butelek plastikowych', code: 'PLASTIC5-10OFF' },
    { id: 3, deviceGroupIds: [1], name: 'Rabat 8% za 4 zwrócone butelki szklane', code: 'GLASS4-8OFF' },
    { id: 4, deviceGroupIds: [2, 3], name: 'Rabat 12% za 6 zwróconych butelek PET 0.5L', code: 'PET05L6-12OFF' },

    { id: 5, deviceGroupIds: [4, 5], name: 'Rabat 7% za 3 zwrócone butelki PET 1L', code: 'PET1L3-7OFF' },
    { id: 6, deviceGroupIds: [4], name: 'Rabat 15% za 6 zwróconych butelek ekologicznych', code: 'ECO6-15OFF' },
    { id: 7, deviceGroupIds: [5], name: 'Rabat 20% za 8 zwróconych puszek aluminiowych', code: 'ALUMINIUM8-20OFF' },

    { id: 8, deviceGroupIds: [6, 7], name: 'Rabat 9% za 4 zwrócone puszki po piwie', code: 'BEERCANS4-9OFF' },
    { id: 9, deviceGroupIds: [6], name: 'Rabat 11% za 5 zwróconych puszek energetycznych', code: 'ENERGY5-11OFF' },
    { id: 10, deviceGroupIds: [7], name: 'Rabat 13% za 6 zwróconych butelek po sokach', code: 'JUICE6-13OFF' },
];

const mockProducts = [
    {
        id: 1,
        name: 'Pepsi-Cola Napój gazowany o smaku cola 1 l',
        ean: '9900AHHK880NM',
        image: 'https://aptekadziecka.pl/hpeciai/dc714d51ba7b8201726ff58f70262af2/pol_pl_Zywiec-Zdroj-Mocny-Gaz-Woda-zrodlana-500-ml-41398_1.png',
        brand: 'Pepsi',
        categoryId: 1,
    },
    {
        id: 2,
        name: 'Coca-Cola Napój gazowany o smaku cola 0.5 l',
        ean: '9900AHHK881NM',
        image: '',
        brand: 'Coca-Cola',
        categoryId: 1,
    },
    {
        id: 3,
        name: 'Sprite Napój gazowany o smaku cytrynowym 0.33 l',
        ean: '9900AHHK882NM',
        image: 'https://aptekadziecka.pl/hpeciai/dc714d51ba7b8201726ff58f70262af2/pol_pl_Zywiec-Zdroj-Mocny-Gaz-Woda-zrodlana-500-ml-41398_1.png',
        brand: 'Sprite',
        categoryId: 1,
    },
    {
        id: 4,
        name: 'Fanta Napój gazowany o smaku pomarańczowym 0.5 l',
        ean: '9900AHHK883NM',
        image: '',
        brand: 'Fanta',
        categoryId: 1,
    },
    {
        id: 5,
        name: 'Red Bull Energy Drink 0.25 l',
        ean: '9900AHHK884NM',
        image: 'https://aptekadziecka.pl/hpeciai/dc714d51ba7b8201726ff58f70262af2/pol_pl_Zywiec-Zdroj-Mocny-Gaz-Woda-zrodlana-500-ml-41398_1.png',
        brand: 'Red Bull',
        categoryId: 2,
    },
    {
        id: 6,
        name: 'Monster Energy Drink 0.5 l',
        ean: '9900AHHK885NM',
        image: '',
        brand: 'Monster',
        categoryId: 2,
    },
    {
        id: 7,
        name: 'Lipton Ice Tea Brzoskwinia 0.5 l',
        ean: '9900AHHK886NM',
        image: 'https://aptekadziecka.pl/hpeciai/dc714d51ba7b8201726ff58f70262af2/pol_pl_Zywiec-Zdroj-Mocny-Gaz-Woda-zrodlana-500-ml-41398_1.png',
        brand: 'Lipton',
        categoryId: 3,
    },
    {
        id: 8,
        name: 'Nestea Herbata mrożona o smaku cytrynowym 0.5 l',
        ean: '9900AHHK887NM',
        image: '',
        brand: 'Nestea',
        categoryId: 3,
    },
    {
        id: 9,
        name: 'Powerade Napój izotoniczny o smaku pomarańczowym 0.5 l',
        ean: '9900AHHK888NM',
        image: 'https://aptekadziecka.pl/hpeciai/dc714d51ba7b8201726ff58f70262af2/pol_pl_Zywiec-Zdroj-Mocny-Gaz-Woda-zrodlana-500-ml-41398_1.png',
        brand: 'Powerade',
        categoryId: 4,
    },
    {
        id: 10,
        name: 'Gatorade Napój sportowy o smaku cytrynowym 0.5 l',
        ean: '9900AHHK889NM',
        image: '',
        brand: 'Gatorade',
        categoryId: 4,
    },
];

const mockProductCategories = [
    { id: 1, name: 'Lemonade', colorDark: '#FFDF7B', colorLight: '#FFF8DF' },
    { id: 2, name: 'Drink', colorDark: '#FFDF7B', colorLight: '#FFF8DF' },
    { id: 3, name: 'Tea', colorDark: '#FFDF7B', colorLight: '#FFF8DF' },
    { id: 4, name: 'Juice', colorDark: '#FFDF7B', colorLight: '#FFF8DF' },
    { id: 5, name: 'Smootie', colorDark: '#FFDF7B', colorLight: '#FFF8DF' },
    { id: 6, name: 'Bottle', colorDark: '#C697FA', colorLight: '#F3E6FE' },
    { id: 7, name: 'Single-Serve', colorDark: '#C697FA', colorLight: '#F3E6FE' },
    { id: 8, name: 'Glass', colorDark: '#C697FA', colorLight: '#F3E6FE' },
    { id: 9, name: 'Eco-Friendly', colorDark: '#C697FA', colorLight: '#F3E6FE' },
    { id: 10, name: 'Sweet', colorDark: '#91C3FF', colorLight: '#E3F0FF' },
    { id: 11, name: 'Citrus', colorDark: '#91C3FF', colorLight: '#E3F0FF' },
    { id: 12, name: 'Sour', colorDark: '#91C3FF', colorLight: '#E3F0FF' },
    { id: 13, name: 'Berry', colorDark: '#91C3FF', colorLight: '#E3F0FF' },
    { id: 14, name: 'Tropical', colorDark: '#91C3FF', colorLight: '#E3F0FF' },
    { id: 15, name: 'Herbal', colorDark: '#91C3FF', colorLight: '#E3F0FF' },
    { id: 16, name: 'Fruit', colorDark: '#94E4AE', colorLight: '#E5F9EB' },
    { id: 17, name: 'Vegetable', colorDark: '#94E4AE', colorLight: '#E5F9EB' },
    { id: 18, name: 'Sugar-Free', colorDark: '#94E4AE', colorLight: '#E5F9EB' },
    { id: 19, name: 'Plant-Based', colorDark: '#94E4AE', colorLight: '#E5F9EB' },
];

const mockCampaignsData = [
    {
        id: 1,
        name: 'Letnia Promocja Recyklingu',
        startDate: new Date('2025-06-01'),
        endDate: new Date('2025-08-30'),
        priority: 0,
        views: 873,
        viewsPercentage: 57,
        conversion: 86.6,
        status: 'Zakończona',
        image: 'https://aptekadziecka.pl/hpeciai/dc714d51ba7b8201726ff58f70262af2/pol_pl_Zywiec-Zdroj-Mocny-Gaz-Woda-zrodlana-500-ml-41398_1.png',
        sponsored: true,
        criteria: ['Kaucja: 2 zł', 'Vegan', 'Plant-based', 'Sugar-free', 'Health & Wellness'],
        coupon: ['Rabat: 15%', 'Marka: Foodini', 'Smoothie'],
        conversionData: mockPromotionalCampaignsConversionData,
        viewsData: mockPromotionalCampaignsViewsData,
    },
    {
        id: 2,
        name: 'Rabat na wycisk za napoje herbaciane i drinki 0%',
        startDate: new Date('2025-09-01'),
        endDate: new Date('2025-11-30'),
        priority: 1,
        views: 82,
        viewsPercentage: 12,
        conversion: 47.2,
        status: 'Aktywna',
        image: '',
        sponsored: false,
        criteria: ['Kaucja: 2 zł', 'Vegan', 'Plant-based', 'Sugar-free', 'Health & Wellness'],
        coupon: ['Rabat: 15%', 'Marka: Foodini', 'Smoothie'],
        conversionData: mockPromotionalCampaignsConversionData,
        viewsData: mockPromotionalCampaignsViewsData,
    },
    {
        id: 3,
        name: 'Zielone Święta 2024',
        startDate: new Date('2024-12-01'),
        endDate: new Date('2024-12-31'),
        priority: 0,
        views: 35,
        viewsPercentage: 24,
        conversion: 54.6,
        status: 'Zakończona',
        image: 'https://aptekadziecka.pl/hpeciai/dc714d51ba7b8201726ff58f70262af2/pol_pl_Zywiec-Zdroj-Mocny-Gaz-Woda-zrodlana-500-ml-41398_1.png',
        sponsored: true,
        criteria: ['Kaucja: 2 zł', 'Vegan', 'Plant-based', 'Sugar-free', 'Health & Wellness'],
        coupon: ['Rabat: 15%', 'Marka: Foodini', 'Smoothie'],
        conversionData: mockPromotionalCampaignsConversionData,
        viewsData: mockPromotionalCampaignsViewsData,
    },
    {
        id: 4,
        name: 'Butelki za Punkty',
        startDate: new Date('2025-03-15'),
        endDate: new Date('2025-05-15'),
        priority: 1,
        views: 563,
        viewsPercentage: 34,
        conversion: 12.5,
        status: 'Zakończona',
        image: '',
        sponsored: false,
        criteria: ['Kaucja: 2 zł', 'Vegan', 'Plant-based', 'Sugar-free', 'Health & Wellness'],
        coupon: ['Rabat: 15%', 'Marka: Foodini', 'Smoothie'],
        conversionData: mockPromotionalCampaignsConversionData,
        viewsData: mockPromotionalCampaignsViewsData,
    },
    {
        id: 5,
        name: 'Ekomatowy Maraton',
        startDate: new Date('2025-01-01'),
        endDate: new Date('2025-03-31'),
        priority: 2,
        views: 320,
        viewsPercentage: 20,
        conversion: 8.3,
        status: 'Zakończona',
        image: 'https://aptekadziecka.pl/hpeciai/dc714d51ba7b8201726ff58f70262af2/pol_pl_Zywiec-Zdroj-Mocny-Gaz-Woda-zrodlana-500-ml-41398_1.png',
        sponsored: false,
        criteria: ['Kaucja: 2 zł', 'Vegan', 'Plant-based', 'Sugar-free', 'Health & Wellness'],
        coupon: ['Rabat: 15%', 'Marka: Foodini', 'Smoothie'],
        conversionData: mockPromotionalCampaignsConversionData,
        viewsData: mockPromotionalCampaignsViewsData,
    },
    {
        id: 6,
        name: 'Plastik Zero Waste',
        startDate: new Date('2025-04-10'),
        endDate: new Date('2025-07-10'),
        priority: 0,
        views: 1890,
        viewsPercentage: 10,
        conversion: 46.2,
        status: 'Zakończona',
        image: '',
        sponsored: true,
        criteria: ['Kaucja: 2 zł', 'Vegan', 'Plant-based', 'Sugar-free', 'Health & Wellness'],
        coupon: ['Rabat: 15%', 'Marka: Foodini', 'Smoothie'],
        conversionData: mockPromotionalCampaignsConversionData,
        viewsData: mockPromotionalCampaignsViewsData,
    },
];

const mockAdsCampaignsData = [
    {
        id: 1,
        name: 'Rabat 5% za trzy puszki po piwie',
        image: 'https://i.postimg.cc/c4jQcML4/463264d3d9f72f086d18f92e4918eac2b31ceb02-1.png',
        startDate: new Date('2025-09-01'),
        endDate: new Date('2025-11-30'),
        coupon: 'Rabat 5% za trzy puszki po piwie →',
        group: 'Wszystkie urządzenia',
        displayHours: '',
        status: 'Trwająca',
    },
    {
        id: 2,
        name: 'Kawa za napoje pomarańczowe Bomba',
        image: 'https://i.postimg.cc/c4jQcML4/463264d3d9f72f086d18f92e4918eac2b31ceb02-1.png',
        startDate: new Date('2026-01-01'),
        endDate: new Date('2026-04-20'),
        coupon: 'Kawa za napoje pomarańczowe Bomba →',
        group: 'Wszystkie urządzenia',
        displayHours: '',
        status: 'Zaplanowana',
    },
    {
        id: 3,
        name: 'Zapraszamy na przekąski do naszego pieca',
        image: 'https://i.postimg.cc/c4jQcML4/463264d3d9f72f086d18f92e4918eac2b31ceb02-1.png',
        startDate: new Date('2025-09-01'),
        endDate: new Date('2025-11-30'),
        coupon: 'Rabat 5% za trzy puszki po piwie →',
        group: 'Wszystkie urządzenia',
        displayHours: '',
        status: 'Trwająca',
    },
    {
        id: 4,
        name: 'Wszystkie napoje cytrusowe -10%',
        image: 'https://i.postimg.cc/c4jQcML4/463264d3d9f72f086d18f92e4918eac2b31ceb02-1.png',
        startDate: new Date('2025-01-01'),
        endDate: new Date('2025-06-30'),
        coupon: 'Rabat 5% za trzy puszki po piwie →',
        group: 'Wszystkie urządzenia',
        displayHours: '',
        status: 'Zakończona',
    },
    {
        id: 5,
        name: 'Dwie muszynianki – kawa gratis',
        image: 'https://i.postimg.cc/c4jQcML4/463264d3d9f72f086d18f92e4918eac2b31ceb02-1.png',
        startDate: new Date('2025-04-01'),
        endDate: new Date('2025-06-30'),
        coupon: 'Rabat 5% za trzy puszki po piwie →',
        group: 'Wszystkie urządzenia',
        displayHours: '',
        status: 'Zakończona',
    },
];

const filterData = (data, filters) => {
    return data.filter(item => {
        if (filters.status) {
            if (Array.isArray(filters.status)) {
                if (filters.status.length === 0) {
                    return true;
                }
                return filters.status.includes(item.status);
            } else {
                return item.status === filters.status;
            }
        }
        return true;
    });
};

const sortData = (data, sort) => {
    const { field, order } = sort;
    return [...data].sort((a, b) => {
        let aValue = a[field];
        let bValue = b[field];

        if (typeof aValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
        }

        if (order === 'ASC') {
            return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
        } else {
            return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
        }
    });
};

export const MockDataProvider = {
    ...DataProvider,

    getList: (resource, params) => {
        if (resource === 'product-brands-mock') {
            const { page = 1, perPage = 100 } = params.pagination || {};
            const start = (page - 1) * perPage;
            const end = start + perPage;
            const data = mockProductBrands.map((brand, index) => ({ id: index + 1, brand })).slice(start, end);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data,
                        total: mockProductBrands.length,
                    });
                }, 200);
            });
        }

        if (resource === 'device-groups-mock') {
            const { page = 1, perPage = 100 } = params.pagination || {};
            const start = (page - 1) * perPage;
            const end = start + perPage;
            const data = mockDeviceGroups.slice(start, end);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data,
                        total: mockDeviceGroups.length,
                    });
                }, 200);
            });
        }

        if (resource === 'coupons-mock') {
            const { page = 1, perPage = 100 } = params.pagination || {};
            const filters = params.filter || {};
            let filtered = mockCoupons;

            if (filters.deviceGroupIds && Array.isArray(filters.deviceGroupIds) && filters.deviceGroupIds.length > 0) {
                // Pokazuj tylko kupony, które są wspólne dla WSZYSTKICH wybranych grup
                filtered = mockCoupons.filter(coupon => filters.deviceGroupIds.every(groupId => coupon.deviceGroupIds.includes(groupId)));
            }

            const start = (page - 1) * perPage;
            const end = start + perPage;
            const data = filtered.slice(start, end);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data,
                        total: filtered.length,
                    });
                }, 200);
            });
        }

        if (resource === 'product-categories-mock') {
            const { page = 1, perPage = 100 } = params.pagination || {};
            const start = (page - 1) * perPage;
            const end = start + perPage;

            const data = mockProductCategories.slice(start, end);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data,
                        total: mockProductCategories.length,
                    });
                }, 200);
            });
        }

        if (resource === 'product-mock') {
            const { page = 1, perPage = 100 } = params.pagination || {};
            const filters = params.filter || {};

            let filtered = mockProducts;

            if (filters.search && typeof filters.search.value === 'string') {
                const searchValue = String(filters.search.value).toLowerCase();
                const fieldsObj = filters.search.fields || {};
                const fields = Object.keys(fieldsObj).length ? Object.keys(fieldsObj).filter(k => fieldsObj[k]) : ['name'];

                filtered = mockProducts.filter(product => {
                    return fields.some(fieldName => {
                        const fieldValue = (product?.[fieldName] ?? '').toString().toLowerCase();
                        return fieldValue.includes(searchValue);
                    });
                });
            }

            const start = (page - 1) * perPage;
            const end = start + perPage;
            const data = filtered.slice(start, end);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data,
                        total: filtered.length,
                    });
                }, 200);
            });
        }

        if (resource === 'promotional-campaigns') {
            const { page, perPage } = params.pagination;
            const { field = 'id', order = 'ASC' } = params.sort;
            const filters = params.filter || {};

            let filteredData = filterData(mockCampaignsData, filters);

            const sortedData = sortData(filteredData, { field, order });

            const start = (page - 1) * perPage;
            const end = start + perPage;
            const paginatedData = sortedData.slice(start, end);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: paginatedData,
                        total: filteredData.length,
                    });
                }, 300);
            });
        }

        if (resource === 'ads-campaigns') {
            const { page = 1, perPage = 100 } = params.pagination;
            const { field = 'id', order = 'ASC' } = params.sort;
            const filters = params.filter || {};

            let filteredData = filterData(mockAdsCampaignsData, filters);

            const sortedData = sortData(filteredData, { field, order });

            const start = (page - 1) * perPage;
            const end = start + perPage;
            const paginatedData = sortedData.slice(start, end);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: paginatedData,
                        total: filteredData.length,
                    });
                }, 300);
            });
        }

        return DataProvider.getList(resource, params);
    },

    getOne: (resource, params) => {
        if (resource === 'product-mock') {
            const item = mockProducts.find(product => product.id === params.id);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: item || null,
                    });
                }, 200);
            });
        }

        if (resource === 'product-categories-mock') {
            const item = mockProductCategories.find(cat => cat.id === params.id);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: item || null,
                    });
                }, 200);
            });
        }

        if (resource === 'promotional-campaigns') {
            const item = mockCampaignsData.find(campaign => campaign.id === params.id);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: item || null,
                    });
                }, 200);
            });
        }

        if (resource === 'ads-campaigns') {
            const item = mockAdsCampaignsData.find(campaign => campaign.id === params.id);

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: item || null,
                    });
                }, 200);
            });
        }

        return DataProvider.getOne(resource, params);
    },

    getMany: (resource, params) => {
        if (resource === 'product-mock') {
            const items = mockProducts.filter(product => params.ids.includes(product.id));

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: items,
                    });
                }, 200);
            });
        }

        if (resource === 'product-brands-mock') {
            const items = mockProductBrands.map((brand, index) => ({ id: index + 1, brand })).filter(item => params.ids.includes(item.id));

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: items,
                    });
                }, 200);
            });
        }

        if (resource === 'device-groups-mock') {
            const items = mockDeviceGroups.filter(group => params.ids.includes(group.id));

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: items,
                    });
                }, 200);
            });
        }

        if (resource === 'coupons-mock') {
            const items = mockCoupons.filter(coupon => params.ids.includes(coupon.id));

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: items,
                    });
                }, 200);
            });
        }

        if (resource === 'product-categories-mock') {
            const items = mockProductCategories.filter(cat => params.ids.includes(cat.id));

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: items,
                    });
                }, 200);
            });
        }

        if (resource === 'promotional-campaigns') {
            const items = mockCampaignsData.filter(campaign => params.ids.includes(campaign.id));

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: items,
                    });
                }, 200);
            });
        }

        if (resource === 'ads-campaigns') {
            const items = mockAdsCampaignsData.filter(campaign => params.ids.includes(campaign.id));

            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({
                        data: items,
                    });
                }, 200);
            });
        }

        return DataProvider.getMany(resource, params);
    },
};
